import { compose } from 'ramda';
import { selectors as customOptions } from '../state/custom-options';
import root from './root';

export default {
  keyword: compose(
    customOptions.keyword,
    root.customOptions,
  ),
  articleUrl: compose(
    customOptions.articleUrl,
    root.customOptions,
  ),
  hideCloseButton: compose(
    customOptions.hideCloseButton,
    root.customOptions,
  ),
};
